import React, { useEffect, useState } from 'react'
import {
  CModal,
  CModalBody,
  CModalFooter,
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CFormLabel,
  CFormInput,
  CButton,
  CSpinner,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalHeader,
  CModalTitle,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormTextarea,
} from '@coreui/react'
import { FilePlus2, Plus, Trash } from 'lucide-react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat'
import Graytextarea from '../../components/Graytextarea'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { color } from '@cloudinary/url-gen/qualifiers/background'
const IncidentHqFinalNote = ({ diagnosis, showDataIfNoteIsFollowUp, saveTreatsShell, setAddedNewIncident, patientID = '', noteID, noteStructureRef, isAllotedToProvider, patientDiagnosis, appointments, UpdateCheckForStatusData }) => {
  const [visible, setVisible] = useState(false)
  const [allDiagnosis, setAllDiagnosis] = useState([])
  const [date, setDate] = useState('')
  const [incidentRemark, setIncidentRemark] = useState(noteStructureRef?.current?.incidentRemark || '')
  const [tempModalIncidentRemark, setTempModalIncidentRemark] = useState('')
  const [toggleToAddIncidentRemark, setToggleToAddIncidentRemark] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deleteID, setDeleteID] = useState(null)
  const hiddenInputStyles = {
    input: (base) => ({
      ...base,
      background: 'transparent',
      color: 'inherit',
      width: '100%',
      gridArea: '1 / 2',
      font: 'inherit',
      minWidth: '2px',
      border: 0,

      margin: 0,
      outline: 0,
      padding: 0,
    }),
    inputContainer: (base) => ({
      ...base,
      color: 'inherit',
    }),
  }
  const handleAddNewIncident = async () => {
    if (!selectedDiagnosis) {
      toast.error('Please select diagnosis', toastConfig)
      return
    }
    if (!date) {
      toast.error('Please select Date', toastConfig)
      return
    }
    const findDiagnosisId = allDiagnosis?.find((item) => item.label === selectedDiagnosis)
    if (findDiagnosisId) {
      let data = await SaveQuestionProvider('GET', '', 'Incident', findDiagnosisId?.value, '')
      data = JSON.parse(data?.d)?.Data || []
      const allParsedData = data.flatMap((item) => {
        try {
          const parsed = JSON.parse(item.questionData)
          return Array.isArray(parsed) ? parsed : []
        } catch (err) {
          console.error('Invalid JSON in questionData:', item.questionData)
          return []
        }
      })
      if (allParsedData.length > 0) {
        let isoString
        if (date) {
          const [month, day, year] = date?.split('/')
          const dateToIso = new Date(`${year}-${month}-${day}`)
          isoString = dateToIso.toISOString()
        }
        setAllIncidents([...allIncidents, { diagnosis: findDiagnosisId?.label, date: isoString, incidents: allParsedData }])

        setVisible(false)
        setDate('')
        setSelectedDiagnosis(null)
      } else {
        toast.error('No incident question are available', toastConfig)
        return
      }
    }
  }
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [allIncidents, setAllIncidents] = useState([])



  const handleDateChange = (e) => {
    setDate(e)
  }

  // useEffect(() => {
  //     const incidentObj = noteStructureRef?.current?.incident;
  //     if (!incidentObj) return;

  //     const allKeys = Object.keys(incidentObj);

  //     const structuredIncidents = allKeys.map(key => {
  //         const [diagnosis, date] = key.split("_");
  //         return {
  //             diagnosis,
  //             date,
  //             incidents: incidentObj[key]
  //         };
  //     });

  //     setAllIncidents(structuredIncidents);
  // }, [noteStructureRef?.current]);
  useEffect(() => {
    const incidentObj = noteStructureRef?.current?.incident
    const incideRemrk = noteStructureRef?.current?.incidentRemark || ''
    if (!incidentObj) {
      if (incidentRemark) {
        setIncidentRemark(incideRemrk || '')
      }
      return
    }

    const allKeys = Object.keys(incidentObj)

    const structuredIncidents = allKeys
      .filter((key) => Array.isArray(incidentObj[key]))
      .map((key) => {
        const [diagnosis, date] = key.split('_')
        return {
          diagnosis,
          date,
          incidents: incidentObj[key],
        }
      })

    setAllIncidents(structuredIncidents)
    setIncidentRemark(incideRemrk || '')
  }, [])

  const [freetypeModal, setFreetypeModal] = useState(false)
  const [currentIncidentIndex, setCurrentIncidentIndex] = useState(null)
  const [newFreeTypeText, setNewFreeTypeText] = useState('')
  // fetch diagnosis
  const fetchDiagnosis = async () => {
    let diagnosisData = await GetDiagnosisData('')
    diagnosisData = JSON.parse(diagnosisData.d)?.Data
    if (diagnosisData.length > 0) {
      const allDiagnosisOpt = diagnosisData
        .map((diagnosis) => {
          return {
            value: diagnosis.id,
            label: diagnosis.Name,
          }
        })
        ?.sort((a, b) => a.label.localeCompare(b.label))
      setAllDiagnosis(allDiagnosisOpt)
    }
  }

  const handleDeleteIncident = (index) => {
    const updatedIncidents = allIncidents.filter((_, i) => i !== index)
    setAllIncidents(updatedIncidents)
    setDeleteVisible(false)
    setDeleteID(null)
  }

  useEffect(() => {
    fetchDiagnosis()
  }, [visible])
  const [isSavingIncident, setIsSavingIncident] = useState(false)

  // const handleSave = async () => {
  //   setIsSavingIncident(true)
  //   allIncidents.forEach((item) => {

  //     const key = `${item.diagnosis}_${item.date}`
  //     noteStructureRef.current = {
  //       ...noteStructureRef.current,
  //       incident: {
  //         ...noteStructureRef.current.incident,
  //         [key]: item?.incidents || [],
  //       },
  //     }
  //   })
  //   const deleteData = noteStructureRef?.current
  //   await saveTreatsShell(false)
  //   setAddedNewIncident((p) => !p)
  //   toast.success('Incident Saved', toastConfig)
  //   setIsSavingIncident(false)
  // }




  const handleSave = async () => {
    setIsSavingIncident(true)

    const newIncidentObject = {}

    allIncidents.forEach((item) => {
      const key = `${item.diagnosis}_${item.date}`

      if (item?.incidents?.length) {
        newIncidentObject[key] = item.incidents
      }
    })

    noteStructureRef.current = {
      ...noteStructureRef.current,
      incident: newIncidentObject,
    }

    const deleteData = noteStructureRef?.current

    await saveTreatsShell(false)

    setAddedNewIncident((p) => !p)
    toast.success('Incident Saved', toastConfig)

    await UpdateCheckForStatusData({ Incident: true })
    setIsSavingIncident(false)
  }
  const updateIncidentAnswerById = (incidents, targetId, updater) => {
    return incidents.map((q) => {
      if (q.id === targetId) {
        return updater(q)
      } else if (q.options?.some((opt) => opt.linkedQuestion?.length)) {
        // find selected options
        let selectedOptions = []
        if (q.isMultiple) {
          const answerArray = q.answer ? q.answer.split(',').map((v) => v.trim()) : []
          selectedOptions = q.options.filter((opt) => answerArray.includes(opt.label))
        } else {
          selectedOptions = q.options.filter((opt) => opt.label === q.answer)
        }

        return {
          ...q,
          options: q.options.map((opt) => {
            const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []
            if (linkedQuestions?.length) {
              const isSelected = selectedOptions.some((sel) => sel.label === opt.label)
              if (isSelected) {
                return {
                  ...opt,
                  linkedQuestion: updateIncidentAnswerById(linkedQuestions, targetId, updater),
                }
              }
            }
            return opt
          }),
        }
      }
      return q
    })
  }
  const formatDate = (date) => {
    if (!date) return '' // no date available

    const d = new Date(date)

    if (isNaN(d.getTime())) return '' // invalid date

    return new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    }).format(d)
  }

  // const renderIncidentQuestion = (item, incidentIndex, parentPath = []) => {
  const renderIncidentQuestion = (item, incidentIndex, parentPath = [], itemIndex = 0) => {
    const currentPath = [...parentPath, item.id]
    return (
      <div key={item.id} className="mb-3">
        <div className="d-flex align-items-center gap-1 mb-2" style={{ marginBottom: '8px' }}>
          {/* <p className="mb-0">{currentPath.length === 1 ? incidentIndex + 1 : '-'}.</p> */}
          <p className="mb-0">{currentPath.length === 1 ? itemIndex + 1 : '-'}.</p>

          <p className="mb-0">{item?.label}</p>
        </div>

        {item.type === 'dropdown' && (
          <Select
            className="react-select-container ui-react-select"
            classNamePrefix="react-select"
            isMulti={item?.isMultiple}
            menuIsOpen={item?.isMultiple ? undefined : item?.menuIsOpen}
            closeMenuOnSelect={!item?.isMultiple}
            onChange={(selected) => {
              let selectedValues = ''
              let selectedValuesArr = []
              if (item?.isMultiple) {
                selectedValuesArr = selected?.map((opt) => opt.value) || []
                selectedValues = selectedValuesArr.join(', ')
              } else {
                selectedValues = selected?.value || ''
              }

              setAllIncidents((prevData) =>
                prevData.map((incidentBlock, idx) => {
                  if (idx !== incidentIndex) {
                    return incidentBlock
                  }

                  return {
                    ...incidentBlock,
                    incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, answer: selectedValues })),
                  }
                }),
              )
            }}
            value={item?.isMultiple ? (item?.answer && item.answer.trim() ? item.answer.split(',').map((val) => ({ value: val.trim(), label: val.trim() })) : []) : item?.answer && item.answer.trim() ? { value: item.answer, label: item.answer } : null}
            options={item.options?.map((opt) => ({ value: opt.label, label: opt.label })) || []}
            placeholder="Select an option"
            isClearable={!item?.isMultiple}
          />
        )}

        {item.type === 'input' && (
          <input
            type="text"
            className="form-control mt-2"
            value={item.answer || ''}
            onChange={(e) => {
              const val = e.target.value
              setAllIncidents((prevData) =>
                prevData.map((incidentBlock, idx) => {
                  // Only update THIS specific incident by index
                  if (idx !== incidentIndex) return incidentBlock

                  return {
                    ...incidentBlock,
                    incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, answer: val })),
                  }
                }),
              )
            }}
            placeholder="Enter your text"
          />
        )}

        {item.options?.map((opt) => {
          let isSelected = false
          if (item?.isMultiple) {
            const answerArray = item?.answer ? item.answer.split(',').map((v) => v.trim()) : []
            isSelected = answerArray.includes(opt.label)
          } else {
            isSelected = item?.answer === opt.label
          }

          const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

          return (
            isSelected &&
            linkedQuestions?.length > 0 && (
              <div key={`${opt.label}-${item.id}`} className="ml-3 mt-3 border-start ps-3">
                {linkedQuestions.map((nestedItem) => renderIncidentQuestion(nestedItem, incidentIndex, currentPath))}
              </div>
            )
          )
        })}

        <span className="d-block pt-2">
          <Graytextarea
            value={item.freeType || ''}
            onChange={(e) => {
              const val = e.target.value
              setAllIncidents((prevData) =>
                prevData.map((incidentBlock, idx) => {
                  // Only update THIS specific incident by index
                  if (idx !== incidentIndex) return incidentBlock

                  return {
                    ...incidentBlock,
                    incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, freeType: val })),
                  }
                }),
              )
            }}
            height={'100px'}
            placeholder={'Freetype'}
          />
        </span>
      </div>
    )
  }
  return (
    <div className="card mb-4 p-3">
      <CAccordion className="border-0" flush>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <div className="patient-note-section-header d-flex gap-3 align-items-center">
              <h6
                className="patient-note-section-title fs-7 p-0 m-0"
                style={{
                  opacity: '0.8',
                }}
              >
                Incident
              </h6>
              {isAllotedToProvider && (
                <CFormLabel
                  className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setVisible((p) => !p)
                  }}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: 'var(--ui-color-primary, #2b7cd3)',
                    cursor: 'pointer',
                  }}
                >
                  <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
                </CFormLabel>
              )}
              <CFormLabel
                className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setToggleToAddIncidentRemark((p) => !p)
                  setTempModalIncidentRemark(incidentRemark || '')
                }}
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '20px',
                  background: 'var(--ui-color-primary, #2b7cd3)',
                  cursor: 'pointer',
                }}
              >
                <FilePlus2 className="patient-note-action-icon" strokeWidth={2} size={15} />
              </CFormLabel>
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            {incidentRemark && (
              <p className="px-4" style={{ whiteSpace: 'pre-line' }}>
                {incidentRemark || ''}
              </p>
            )}

            <CAccordion flush>
              {allIncidents.length > 0 &&
                allIncidents.map((incident, index) => {
                  return (
                    <CAccordionItem itemKey={1}>
                      <CAccordionHeader className="incident-note-accordion-header">
                        <div className="d-flex justify-content-between w-100">
                          <div>
                            {incident?.diagnosis} - {formatDate(incident?.date)}
                          </div>
                          <div className="d-flex gap-3 align-items-center incident-note-row-actions">
                            <span
                              variant="outline"
                              color="secondary"
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                setCurrentIncidentIndex(index)
                                setFreetypeModal(true)
                                const incidentData = allIncidents[index]
                                const firstItem = incidentData?.incidents?.[0]

                                if (firstItem?.freeRemark) {
                                  setNewFreeTypeText(firstItem.freeRemark) // set if it exists
                                } else {
                                  setNewFreeTypeText('') // empty input if not available
                                }

                                setFreetypeModal(true)
                              }}
                            >
                              <FilePlus2 className="text-secondary" size={20} />
                            </span>
                            <span
                              className=""
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                // handleDeleteIncident(index)
                                setDeleteID(index)
                                setDeleteVisible(true)
                              }}
                            >
                              <Trash className="text-danger" />
                            </span>
                          </div>
                        </div>
                      </CAccordionHeader>

                      <CAccordionBody>
                        {/* {incident?.incidents.length > 0 ? (
                          <div>
                            {incident?.incidents.map((item, itemIndex) => (
                              <div key={item.id} className="mb-3">
                                <div className="d-flex items-center gap-1">
                                  <p>{itemIndex + 1}.</p>
                                  <p>{item?.label}</p>
                                </div>

                                {item.type === 'dropdown' && (
                                  <Select
                                    onChange={(e) => {
                                      setAllIncidents((prevData) => {
                                        const newData = [...prevData]
                                        const incidentCopy = { ...newData[index] }
                                        const updatedItems = [...incidentCopy.incidents]
                                        updatedItems[itemIndex] = {
                                          ...updatedItems[itemIndex],
                                          answer: e.value,
                                        }
                                        incidentCopy.incidents = updatedItems
                                        newData[index] = incidentCopy
                                        return newData
                                      })
                                    }}
                                    placeholder="Select an option"
                                    value={item.answer ? { value: item.answer, label: item.answer } : null}
                                    options={
                                      item.options?.map((opt) => ({
                                        value: opt.label,
                                        label: opt.label,
                                      })) || []
                                    }
                                  />
                                )}

                                <span className="d-block pt-2">
                                  <Graytextarea
                                    value={item.freeType}
                                    onChange={(e) => {
                                      setAllIncidents((prevData) => {
                                        const newData = [...prevData]
                                        const incidentCopy = { ...newData[index] }
                                        const updatedItems = [...incidentCopy.incidents]
                                        updatedItems[itemIndex] = {
                                          ...updatedItems[itemIndex],
                                          freeType: e.target.value,
                                        }
                                        incidentCopy.incidents = updatedItems
                                        newData[index] = incidentCopy
                                        return newData
                                      })
                                    }}
                                    height={'100px'}
                                    placeholder={'Freetype'}
                                  />
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No Questions Available</p>
                        )} */}

                        {incident?.incidents.length > 0 ? (
                          <div>
                            {incident?.incidents?.[0]?.freeRemark && <p>{incident?.incidents?.[0]?.freeRemark}</p>}
                            {/* {incident.incidents.map((item, itemIndex) => renderIncidentQuestion(item, index))} */}
                            {incident.incidents.map((item, itemIndex) => renderIncidentQuestion(item, index, [], itemIndex))}
                          </div>
                        ) : (
                          <p>No Questions Available</p>
                        )}
                      </CAccordionBody>
                    </CAccordionItem>
                  )
                })}
            </CAccordion>
            <div className="d-flex align-items-center justify-content-center mt-2">
              <CButton
                color="primary"
                onClick={handleSave}
                disabled={allIncidents.length === 0 && !incidentRemark}
                className="ui-action-btn ui-action-btn--primary w-auto"
                style={{ minWidth: '96px' }}
              >
                {isSavingIncident ? <CSpinner size="sm" color="light" role="status" aria-hidden="true" /> : 'Save'}
              </CButton>
            </div>
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>

      <CModal className="incident-modal" centered visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Add Incident</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            height: '400px',
          }}
          className="d-flex  justify-content-center"
        >
          <div className="w-50 d-flex flex-column gap-3">
            <Select
              placeholder="Select Diagnosis"
              options={allDiagnosis}
              onChange={(e) => setSelectedDiagnosis(e.label)}
              value={allDiagnosis.find((item) => item.label === selectedDiagnosis) || null}
              className="basic-single-select"
              classNamePrefix="select"
            />

            <div className="d-flex align-items-center gap-3">
              <CFormLabel className="fw-medium mb-0">Incident Date:</CFormLabel>
              {/* <CFormInput
                                                      type="date"
                                                      value={date}
                                                      onChange={(e) => handleDateChange(e)}
                                                      // disabled={type === "note" ? false : true}
                                                      style={{
                                                          width: "180px",
                                                          height: "32px",
                                                          fontSize: "14px",
                                                          padding: "4px 8px",
                                                      }}
                                                  /> */}
              <CustomDatePickingFormat value={date} onChange={handleDateChange} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            variant="outline"
            onClick={() => {
              setVisible(false)
              setDate('')
              setSelectedDiagnosis(null)
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton
            onClick={handleAddNewIncident}
            style={{
              backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
              borderColor: 'var(--ui-color-primary, #2b7cd3)',
              color: 'white',
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal
        visible={freetypeModal}
        size="lg"
        onClose={() => {
          setFreetypeModal(false)
          setNewFreeTypeText('')
        }}
      >
        <CModalHeader>
          <CModalTitle>Add Note</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Graytextarea placeholder="Enter freetype" value={newFreeTypeText} rows={4} onChange={(e) => setNewFreeTypeText(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary"
            variant="outline"
            onClick={() => {
              setFreetypeModal(false)
              setNewFreeTypeText('')
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              const updatedIncidents = [...allIncidents]
              const textToBeAddInDiagnosis = updatedIncidents[currentIncidentIndex]

              if (textToBeAddInDiagnosis?.incidents?.length > 0) {
                const original = textToBeAddInDiagnosis.incidents[0]

                const updatedFirstItem = {
                  ...original,
                  freeRemark: newFreeTypeText,
                }

                // Replace 0 index with updated version
                const newIncidentArray = [updatedFirstItem, ...textToBeAddInDiagnosis.incidents.slice(1)]

                updatedIncidents[currentIncidentIndex] = {
                  ...textToBeAddInDiagnosis,
                  incidents: newIncidentArray,
                }

                setAllIncidents(updatedIncidents)
                toast.success('Free remark added to first incident', toastConfig)
                setFreetypeModal(false)
                setNewFreeTypeText('')
              } else {
                toast.error('No incident available to update', toastConfig)
              }
            }}
            style={{
              backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
              borderColor: 'var(--ui-color-primary, #2b7cd3)',
              color: 'white',
            }}
          >
            Add
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal
        visible={toggleToAddIncidentRemark}
        size="lg"
        onClose={() => {
          setToggleToAddIncidentRemark(false)
        }}
      >
        <CModalHeader>
          <CModalTitle>Add Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Graytextarea placeholder="Enter freetype" value={tempModalIncidentRemark} rows={4} onChange={(e) => setTempModalIncidentRemark(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary"
            variant="outline"
            onClick={() => {
              setToggleToAddIncidentRemark(false)
              setTempModalIncidentRemark('')
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              setToggleToAddIncidentRemark(false)
              setIncidentRemark(tempModalIncidentRemark)
              noteStructureRef.current = {
                ...noteStructureRef.current,
                incidentRemark: tempModalIncidentRemark,
              }
            }}
            style={{
              backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
              borderColor: 'var(--ui-color-primary, #2b7cd3)',
              color: 'white',
            }}
          >
            Add
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>Are you sure you want to delete?</p>
        </CModalBody>

        <CModalFooter>
          <CButton
            onClick={() => {
              setDeleteVisible(false)
              setDeleteID(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={() => handleDeleteIncident(deleteID)} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default IncidentHqFinalNote
